import axios from 'axios';

const configuredBaseUrl = process.env.REACT_APP_API_URL || 'https://calendario.centrospaziovitale.it:3002/server/';
const baseURL = configuredBaseUrl.endsWith('/') ? configuredBaseUrl : `${configuredBaseUrl}/`;

export const makeRequest = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
